import { useNavigate } from "react-router-dom";
import { SignupForm } from "../features/authentication/signUp/index";
import CFooter from "../layouts/footer/footer";
import CNavBar from "../layouts/Navbar";

const Home = (props) => {

  const navigate = useNavigate();

  const setLogin = () => {
    navigate("/login");
  };

  return (
    <>
      <CNavBar
        isButton={true}
        isbrandText={true}
        brandText={"Reachello"}
        brandTextStyle={{color: "#044389",fontWeight:"bold"}}
        navBgColor={"white"}
        menuAlignment={"right"}
        btnClassDiv={"col-sm-4 mb-sm-2 mt-sm-2"}
        buttonListArray={["Login"]}
        setAction = {()=>setLogin()}
        btnCustomStyle={{
          border: "1px solid black",
          backgroundColor: "white",
          color: "#044389",
        }}
        btnClasses={"px-4 me-3"}
        btnFontWeight={"bold"}
        spaceBetweenItems={5}
      />
      <SignupForm setReg = {(status)=>props.setRegStatus(status)}/>
      <CFooter
        copyRightBlockAlignment={"right"}
        copyRightTextAlignment={"right"}
      />
    </>
  );
};

export default Home;
